<template>
  <div>
    <div class="eig-filter clearfix">
      <div class="eig-rght pa-xs">
        <el-button type="primary" @click="addclassDialog">新增标签</el-button>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="!isEdit ? '新增赛事标签' : '编辑赛事标签'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div class="px-xs">
        <el-form
          :model="addClassForm"
          :rules="rules"
          ref="addClassFormRef"
          label-width="100px"
        >
          <el-form-item label="标签名称" prop="title">
            <el-input v-model="addClassForm.title"></el-input>
          </el-form-item>
          <el-form-item label="标签权重" prop="serial">
            <el-input-number
              v-model="addClassForm.serial"
              :min="1"
              :max="10000"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="标签颜色" prop="color">
            <el-color-picker
              style="margin-top: 4px"
              size="small"
              v-model="addClassForm.color"
            ></el-color-picker>
            <!-- <el-upload
              class="avatar-uploader"
              name="img"
              :action="$http.defaults.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="addClassForm.url"
                :src="$http.defaults.resource + addClassForm.url"
                fit="contain"
                class="avatar"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload> -->
          </el-form-item>
          <el-form-item label="标签图片" prop="url">
            <el-upload
              class="avatar-uploader"
              name="img"
              :action="$http.defaults.baseURL + '/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="addClassForm.url"
                :src="$http.defaults.resource + addClassForm.url"
                fit="contain"
                class="avatar"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="标签介绍" prop="introduction">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入标签介绍"
              v-model="addClassForm.introduction"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="关联赛事" prop="relateMatch">
            <el-select
              v-model="addClassForm.relateMatch"
              multiple
              filterable
              style="width: 100%"
              placeholder="请选择组别"
            >
              <el-option
                v-for="item in matchList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addClassFormRef')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-table
      ref="filterTable"
      :data="page.blogs"
      style="width: 100%"
      :default-sort="{ prop: 'serial', order: 'descending' }"
    >
      <el-table-column type="index" label="序号" width="120"></el-table-column>
      <el-table-column prop="serial" label="权重" width="120"></el-table-column>
      <el-table-column prop="title" label="标签名"></el-table-column>
      <el-table-column
        prop="relateMatch"
        label="已关联赛事"
        show-overflow-tooltip
      >
        <template scope="scope">
          <span>
            {{ scope.row.relateMatch | filterRelate(matchList) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <!-- <el-button
            type="info"
            size="mini"
            @click="reply(scope.row)"
          >修改</el-button> -->
          <!-- <el-tooltip
            effect="dark"
            content="上移"
            placement="top"
          >
            <el-button
              size="small"
              icon="el-icon-top"
              circle
              @click="moveInfo(scope.row,scope.$index,'up')"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            content="下移"
            placement="top"
          >
            <el-button
              circle
              icon="el-icon-bottom"
              size="small"
              @click="moveInfo(scope.row,scope.$index,'down')"
            ></el-button>
          </el-tooltip> -->
          <el-tooltip effect="dark" content="编辑" placement="top">
            <el-button
              circle
              icon="el-icon-edit"
              size="small"
              @click="editInfo(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip effect="dark" content="删除" placement="top">
            <el-button
              circle
              size="small"
              icon="el-icon-delete"
              @click="deleteInfo(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :close-on-click-modal="false"
      title="删除"
      :visible.sync="dialogFormVisible"
      :lock-scroll="false"
      width="35%"
    >
      <span>是否删除 "{{ deleteObj.title }}" </span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="haddledeleteInfo" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      // 绑定表单数据
      addClassForm: {
        id: "",
        title: "",
        serial: 1,
        introduction:'',
        relateMatch: [],
        url:'',
      },
      matchList: [],
      rules: {
        title: [
          {
            required: true,
            message: "请输入标签名称",
            trigger: "blur",
          },
          { min: 2, max: 10, message: "长度在 2 到 10个字符", trigger: "blur" },
        ],
        serial: [
          {
            required: true,
            message: "请输入权重",
            trigger: "blur",
          },
        ],
      },
      // 分页
      page: {
        page_size: 99999999,
        page_index: 1,
        blogs: [],
        count: 0,
      },
      // 删除博客的数据对象
      deleteObj: {
        title: "",
        id: "",
      },
      // 控制弹窗
      dialogFormVisible: false,
      isEdit: false,
    };
  },
  mounted() {
    this.getMatch();
  },
  filters: {
    filterRelate(relateMatch, matchList) {
      if (relateMatch) {
        return relateMatch
          .map((id) => {
            let findItem = matchList.find((item) => item.id == id);
            if (findItem) {
              return findItem.title;
            } else {
              return "";
            }
          })
          .join("，");
      } else {
        return "";
      }
    },
  },
  methods: {
    // 上传成功
    handleAvatarSuccess(res, file) {
      debugger
      if (res && res.code == 0) {
        this.$set(this.addClassForm, "url", res.data);
      } else {
        this.$message({
          showClose: true,
          message: "上传失败",
          type: "error",
        });
      }
    },
    // 上传之前
    beforeAvatarUpload(file) {
      let ftype = file.type === "image/jpeg" || file.type === "image/png";

      if (!ftype) {
        this.$message.error("上传图片只能是 JPG 或 PNG格式!");
      }
      //设置文件大小限制
      const isLt10M = file.size / 1024 / 1024 < 1;
      if (!isLt10M) {
        this.$message.error("上传的照片大小不能超过 1MB!");
        return false;
      }
      return ftype;
    },
    // 获取赛事
    getMatch() {
      this.$http
        .post("/match/getInfo", {
          page_size: 99999,
          page_index: 1,
          filter: {
            title: "",
            status: "",
            classId: "",
            timeStatus: "",
            adminId: "",
            admins: JSON.parse(localStorage.getItem("admins")),
          },
        })
        .then((res) => {
          this.matchList = res.data.blogs;
          this.getInfo();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    submitForm(formName) {
      // 表单验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("match/addLabel", {
              id: this.addClassForm.id,
              title: this.addClassForm.title,
              serial: this.addClassForm.serial,
              url: this.addClassForm.url,
              color: this.addClassForm.color,
              introduction: this.addClassForm.introduction,
              relateMatch: this.addClassForm.relateMatch,
            })
            .then((res) => {
              if (res.status !== 200) {
                this.$message.error("发布失败");
                return;
              }
              this.$message.success("已发布");
              this.getInfo();
              this.dialogVisible = false;
              this.isEdit = false;
            })
            .catch((err) => {
              this.$message.error("发布失败");
              this.dialogVisible = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }, // 占位符方式
    haddledeleteInfo() {
      this.$http
        .delete(`match/deleteLabel/?id=${this.deleteObj.id}`)
        .then((res) => {
          this.dialogFormVisible = false;
          this.getInfo();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 弹出删除博客框
    deleteInfo(row) {
      console.log(row);
      this.deleteObj.id = row.id;
      this.deleteObj.title = row.title;
      this.dialogFormVisible = true;
    },
    // 获取标签
    getInfo() {
      const { page_index, page_size } = this.page;
      this.$http
        .get("match/getLabel", {
          params: {
            page_size,
            page_index,
          },
        })
        .then((res) => {
          if (res.status !== 200) return;
          res.data.blogs.forEach((element) => {
            element.relateMatch = element.relateMatch;
          });
          this.page.blogs = res.data.blogs;
          this.page.count = res.data.count;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 编辑
    editInfo(row) {
      debugger;
      this.addClassForm = JSON.parse(JSON.stringify(row));
      this.isEdit = true;
      this.dialogVisible = true;
    },
    // 当前页改变
    handleCurrentChange(currentPageNumber) {
      console.log(currentPageNumber);
      this.page.page_index = currentPageNumber;
      this.getInfo();
    },
    // 当前每页数据量改变
    handleSizeChange(pageDataCount) {
      console.log(pageDataCount);
      this.page.page_size = pageDataCount;
      this.getInfo();
    },
    // 移动
    moveInfo(row, index, direction) {
      let tableData = this.$refs.filterTable.tableData;
      if (direction == "up") {
        if (index == 0) {
          return this.$message.info("无法再上移了！");
        }
        this.toMoveInfo(row, tableData[index - 1]);
      } else if (direction == "down") {
        if (index == this.page.blogs.length - 1) {
          return this.$message.info("无法再下移了！");
        }
        this.toMoveInfo(row, tableData[index + 1]);
      }
    },
    // 去移动
    toMoveInfo(upRow, downRow) {
      this.$http
        .post("match/moveInfo", {
          upRow,
          downRow,
        })
        .then((res) => {
          if (res.status !== 200) {
            this.$message.error("移动失败");
            return;
          }
          this.getInfo();
        })
        .catch((err) => {
          this.$message.error("移动失败");
        });
    },
    addclassDialog() {
      this.isEdit = false;
      this.addClassForm = {};
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
// 上传部分
.avatar-uploader {
  line-height: 0px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
